module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Header'), _vm._v(" "), _c('Banner', {
    attrs: {
      "title": 'The best place for artists & brands.',
      "imgSrc": _vm.bannerImg
    }
  }), _vm._v(" "), _c('common-section', {
    attrs: {
      "title": 'Upload Music ',
      "title2": '& Share ',
      "title3": 'Upload Videos',
      "title4": '& Share',
      "imgSrc": _vm.img,
      "order1": 1,
      "order2": 2,
      "imgSrc1": _vm.img1,
      "order3": 2,
      "order4": 1,
      "bg": true,
      "list1": _vm.musicList,
      "list2": _vm.videoList
    }
  }), _vm._v(" "), _c('common-section', {
    attrs: {
      "title": 'Sell Your',
      "title2": 'Products',
      "title3": 'Multiple',
      "title4": 'Revenue Streams',
      "imgSrc": _vm.img2,
      "order1": 1,
      "order2": 2,
      "imgSrc1": _vm.img3,
      "order3": 2,
      "order4": 1,
      "bg": false,
      "list1": _vm.productList,
      "list2": _vm.streamsList
    }
  }), _vm._v(" "), _c('common-section', {
    attrs: {
      "title": 'Measure & Grow',
      "title2": 'Your Audience',
      "title3": 'Become a Partner',
      "title4": '& Earn More',
      "imgSrc": _vm.img4,
      "order1": 1,
      "order2": 2,
      "imgSrc1": _vm.img5,
      "order3": 2,
      "order4": 1,
      "bg": false,
      "list1": _vm.growList,
      "list2": _vm.partnerList
    }
  }), _vm._v(" "), _c('time-line'), _vm._v(" "), _c('join'), _vm._v(" "), _c('Footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-81d7837c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/landingPages/landing2.vue
// module id = 1801
// module chunks = 180